import { withInstall } from '@code-monkey-ui/utils'

import Batch from './src/batch.vue'

export const ElBatch = withInstall(Batch)
export default ElBatch

export * from './src/batch'
export type { BatchInstance } from './src/instance'
